<script>
import SearchLayout from "@/Layouts/SearchLayout.vue";
import TD from "@/Components/Table/Element.vue";
import Label from "@/Components/Settings/Label.vue";
import Input from "@/Components/Settings/Input.vue";
import Select from "@/Components/Select.vue";
import Button from "@/Components/Button.vue";

import { Inertia } from "@inertiajs/inertia";

import { ref, onMounted, watch, computed } from "vue";

export default { layout: SearchLayout };
</script>

<script setup>
const props = defineProps({
  practitioners: Array,
  rooms: Array,
  types: Array,
  errors: Object,
  interval: Number,
  freeSlots: Array,
  start: String,
  end: String,
  raum: String,
  behandler: String,
  dauer: String,
  noFreeSlots: Boolean,
});

const canEdit = Inertia.page.props.auth.can["edit appointments"];

const date_start = ref(props.start);
const date_end = ref(props.end);

const room_id = ref(props.raum);
const practitioner_id = ref(props.behandler);

const duration = ref(props.dauer);

function createAppointment(slot) {
  if (canEdit) {
    Inertia.visit(`/termin-erstellen`, {
      method: "get",
      data: {
        date: slot.dateString,
        time: slot.startString,
        behandler: practitioner_id.value,
      },
    });
  }

  //console.log(slot);
}

const userName = computed(() => {
  if (practitioner_id.value) {
    return props.practitioners.find((p) => p.id == props.behandler).fullname;
  }
  return "";
});

const roomName = computed(() => {
  if (room_id.value) {
    return props.rooms.find((r) => r.id == props.raum).name;
  }
  return "";
});

const noSlotsFound = ref(props.noFreeSlots);

function searchSlots() {
  noSlotsFound.value = false;
  Inertia.get("/termin-suchen?search=search", {
    start: date_start.value,
    end: date_end.value,
    raum: room_id.value,
    behandler: practitioner_id.value,
    dauer: duration.value,
    search: "search",
  });
}

function startChanged() {
    const d = new Date(date_start.value);
    d.setDate(d.getDate() + 7);

    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    date_end.value = [year, month, day].join('-');
}
</script>

<template>
  <div class="w-[33%] pr-14">
    <div class="">
      <Label value="Behandler/in" />

      <Select required class="w-full mr-4" v-model="practitioner_id">
        <option disabled value="" class="">Bitte wählen</option>

        <option v-for="u in practitioners" :key="u.id" :value="u.id">
          {{ `${u.firstname} ${u.lastname}` }}
        </option>
      </Select>
      <div class="text-red-600 text-sm" v-if="errors.behandler">
        {{ errors.behandler }}
      </div>
    </div>

    <div class="mt-8">
      <Label value="Behandlungsraum" />
      <Select required class="w-full mr-4" v-model="room_id">
        <option disabled value="" class="">Bitte wählen</option>

        <option v-for="r in rooms" :key="r.id" :value="r.id">
          {{ `${r.name}` }}
        </option>
      </Select>
      <div class="text-red-600 text-sm" v-if="errors.raum">
        {{ errors.raum }}
      </div>
    </div>

    <!-- <div class="mt-8">
      <Label value="Behandlungstyp" />
      <Select class="w-full  mr-4 " v-model="type">
        <option disabled value="" class="">Bitte wählen</option>
        <option v-for="t in types" :key="t.id" :value="t.id">
          {{ `${t.name}` }}
        </option>
      </Select>
    </div> -->

    <div class="mt-8">
      <Label value="Mindestdauer" />
      <Select required class="w-full mr-4" v-model="duration">
        <option disabled value="" class="">Bitte wählen</option>

        <option v-for="n in 10" :key="n" :value="n">
          <!-- {{ n * interval }} Min. -->
          {{ `${n} Einheiten` }} - {{ n * interval }} Min.
        </option>
      </Select>
      <div class="text-red-600 text-sm" v-if="errors.dauer">
        {{ errors.dauer }}
      </div>
    </div>

    <div class="mt-8">
      <Label value="Datum" />
      <div class="flex gap-4">

        <Input required class="w-full" type="date" v-model="date_start" @change="startChanged()" />

        <Input
          required
          class="w-full"
          type="date"
          :min="date_start"
          v-model="date_end"
        /><!--
            @focus="
              () => {
                if (!date_end) {
                  date_end = date_start;
                }
              }
            " -->

      </div>
      <div class="text-red-600 text-sm" v-if="errors.start || errors.end">
        {{ errors.start }}
        <br v-if="errors.start" />
        {{ errors.end }}
      </div>
    </div>

    <div class="mt-8">
      <Button @click="searchSlots" class="w-full">Termine suchen</Button>
    </div>
  </div>

  <div class="w-[67%]">
    <div v-if="freeSlots.length > 0" class="mb-8 text-lg font-light">
      <span class="font-semibold">{{ freeSlots.length }} freie Termine</span>
      vom
      {{
        new Date(props.start).toLocaleDateString("de-DE", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
      }}
      bis
      {{
        new Date(props.end).toLocaleDateString("de-DE", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
      }}
    </div>
    <div class="max-h-[530px] overflow-y-scroll">
      <table class="min-w-full">
        <thead class="bg-white border-b">
          <tr class="sticky -top-px border-white border-t bg-white">
            <th
              scope="col"
              class="
                text-sm
                font-medium
                text-gray-900
                px-6
                py-4
                text-left
                border-x-2
              "
            >
              Behandler/in
            </th>
            <th
              scope="col"
              class="
                text-sm
                font-medium
                text-gray-900
                px-6
                py-4
                text-left
                border-x-2
              "
            >
              Behandlungsraum
            </th>

            <th
              scope="col"
              class="
                text-sm
                font-medium
                text-gray-900
                px-6
                py-4
                text-left
                border-x-2
              "
            >
              Datum
            </th>
            <th
              scope="col"
              class="
                text-sm
                font-medium
                text-gray-900
                px-6
                py-4
                text-left
                border-x-2
              "
            >
              Wochentag
            </th>
            <th
              scope="col"
              class="
                text-sm
                font-medium
                text-gray-900
                px-6
                py-4
                text-left
                border-x-2
              "
            >
              Zeit
            </th>

            <!-- <th
              scope="col"
              class="
                text-sm
                font-medium
                text-gray-900
                px-6
                py-4
                text-left
                border-x-2
              "
            >
              Slots
            </th> -->
          </tr>
        </thead>
        <tbody class="">
          <tr
            v-for="(slot, index) in freeSlots"
            :key="slot.id"
            class="border-b"
            :class="{
              'bg-gray-100': index % 2 === 0,
              'cursor-pointer': canEdit,
            }"
            @click="createAppointment(slot)"
          >
            <TD>
              {{ userName }}
            </TD>
            <TD> {{ roomName }} </TD>

            <TD> {{ `${slot.dateString}` }} </TD>
            <TD> {{ `${slot.weekday}` }} </TD>
            <TD> {{ `${slot.startString} - ${slot.endString} Uhr` }} </TD>
            <!-- <TD> {{ `${slot.amount}` }} </TD> -->
          </tr>

          <!-- <tr>
          <TD></TD>
          <TD></TD>
          <TD></TD>
          <TD></TD>
          <TD></TD>
          <TD></TD>
        </tr> -->
        </tbody>
      </table>
      <div class="mt-4" v-if="noSlotsFound">
        Keine freien Termine in diesem Zeitraum gefunden.
      </div>
      <div
        class="sticky bottom-0 h-10 w-full bg-gradient-to-t from-white"
      ></div>
      <div class="h-8 w-full bg-transparent" ref="obsElement"></div>
    </div>
  </div>
</template>
